import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface DeleteCustomerMemoParams {
    customerId: number;
    memoId: number;
}

export const useDeleteCustomerMemo = (successCallback?: () => void): UseMutationResult<null, Error, DeleteCustomerMemoParams, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, DeleteCustomerMemoParams>({
        mutationFn: async ({ customerId, memoId }: DeleteCustomerMemoParams) => {
            const response = await axios.delete(
                enum_api_uri.put_customer_memo
                    .replace(":customer_idx", customerId.toString())
                    .replace(":customer_memo_idx", memoId.toString()),
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerMemo"] });
            successCallback?.();
        },
    });
};
